module.exports = __webpack_public_path__ + "static/media/closeIcon.d219bc64.svg";